import { FeatureFlag } from '../FeatureFlag';
import { z } from 'zod';

export const ScrollingFastIdeaDwellTimeConfigSchema = z.object({
    scrollingDwellTimeSeconds: z.number(),
});

export type ScrollingFastIdeaDwellTimeConfig = z.infer<typeof ScrollingFastIdeaDwellTimeConfigSchema>;

export const scrollingFastIdeaDwellTimeConfig = new FeatureFlag<ScrollingFastIdeaDwellTimeConfig>({
    key: 'scrolling-fast-idea-dwell-time-config',
    createdOn: '2025-10-31',
    defaultValue: { scrollingDwellTimeSeconds: 1 },
});
